// extracted by mini-css-extract-plugin
module.exports = {"container":"userGroupMemberships_container__3dIU6","userGroup":"userGroupMemberships_userGroup__T7FMu","header":"userGroupMemberships_header__3V-e1"};